import PropTypes from "prop-types";
import React, { useState } from "react";
import { Card } from "react-bootstrap";
import DropdownItem from "react-bootstrap/DropdownItem";
import Tab from "react-bootstrap/Tab";
import { CHART_MODE_CHART, CHART_MODE_TABLE, NUMBER } from "../../../../../ducks/collapsibleTableChart";
import { QuestionIcon } from "../../../../../utils/QuestionUtils";
import { getObjectFromList, getSubQuestionModifiedId } from "../../../../../utils/TableUtils";
import CollapsibleCardHeader from "../CollapsibleCardHeader";
import HorizontalTable from "../HorizontalTable";

const MatrixQuestion = ({
                            subQuestion,
                            collapsibleTablesDetails,
                            modalSelectParameters,
                            renderHeader,
                            renderChart,
                            renderPivotBreadcrumb,
                            handleClickDownloadPivotQuestion,
                            handleModalOpen,
                            handlePivotShortcutSubmit,
                            handlePercentageClick,
                            getQuestionPath,
                            getBreadcrumbPath,
                            pivotShortcut,
                            percentage,
                            sinceBeginning,
                            tabActive,
                            onTabClick
                        }) => {
    const tabIds = [];
    let headers = [];
    let rows = [];
    let defaultActive;

    const [chartMode, setChartMode] = useState();

    const handleSelectChartMode = () => {
        setChartMode(CHART_MODE_CHART);
    };

    const handleSelectTableMode = () => {
        setChartMode(CHART_MODE_TABLE);
    };

    subQuestion.anwser.anwserList.forEach((table, index) => {
       let subquestionId = subQuestion.questionId;
        let subquestionType = subQuestion.questionType;

        let colId;
        let rowId;
        let colKey;
        let rowKey;
        let identifier;
        if (table && table.tableIdentifier) {
            colId = table.tableIdentifier.colId;
            rowId = table.tableIdentifier.rowId;
            colKey = table.tableIdentifier.columnKey;
            rowKey = table.tableIdentifier.rowKey;
            identifier =
                colKey || rowKey
                    ? colKey
                        ? colKey.toString()
                        : "" + rowKey
                            ? rowKey.toString()
                            : ""
                    : (colId ? colId.toString() : "0") + (rowId ? rowId.toString() : "0");
        }

        let title = table.title ? table.title : table.zaxisDesc;
        let subquestionModifiedId = getSubQuestionModifiedId(subQuestion.questionId, identifier, rowId, colId);
        const parameters = modalSelectParameters[subquestionModifiedId];
        if (!defaultActive) {
            defaultActive = subquestionModifiedId;
        }
        tabIds.push(subquestionModifiedId);
        let detailsShown = getObjectFromList(collapsibleTablesDetails, subquestionModifiedId);
        headers.push(
            <DropdownItem
                key={subquestionModifiedId}
                eventKey={subquestionModifiedId}
                active={tabActive === subquestionModifiedId}
                onClick={() => {
                    if (tabActive !== subquestionModifiedId) {
                        onTabClick(subquestionModifiedId);
                    }
                }}
            >
                {renderHeader(
                    detailsShown,
                    title,
                    subquestionType,
                    subquestionModifiedId,
                    subquestionId,
                    colId,
                    rowId,
                    "dynamic",
                    index
                )}
            </DropdownItem>
        );
        const headTitle = <span><QuestionIcon type={subquestionType} /> {title}</span>;
        rows.push(
            <Tab.Pane key={subquestionModifiedId} eventKey={subquestionModifiedId}>
                <Card>
                    <Card.Header>
                        <CollapsibleCardHeader
                            data={table}
                            baseQuestionId={subQuestion.questionId}
                            baseQuestionColId={colId}
                            baseQuestionRowId={rowId}
                            baseQuestionTitle={table.title}
                            shortcutType={pivotShortcut[subquestionModifiedId]?.shortcutType}
                            baseQuestionKey={subQuestion?.questionKey}
                            baseQuestionIdentifier={identifier}
                            baseQuestionRowKey={table?.tableIdentifier?.rowKey}
                            baseQuestionColumnKey={table?.tableIdentifier?.columnKey}
                            baseQuestionGroupKey={""}
                            baseColumnType={subquestionType}
                            isSubquestion={true}
                            baseQuestionType={subQuestion.questionType}
                            chartMode={chartMode}
                            handleClickDownloadQuestion={handleClickDownloadPivotQuestion}
                            handleModalOpen={handleModalOpen}
                            handlePivotShortcutSubmit={handlePivotShortcutSubmit}
                            handleSelectChartModeTable={handleSelectTableMode}
                            handleSelectChartModeChart={handleSelectChartMode}
                            onPercentageClick={handlePercentageClick}
                            baseQuestionString={getQuestionPath(subQuestion.questionTitle, title)}
                            groupByQuestionString={detailsShown ? getBreadcrumbPath(subquestionModifiedId) : ""}
                            percentageOn={percentage}
                            checked={sinceBeginning}
                            status={undefined} // FIXME what is supposed to be passed here?
                            periodCount={subQuestion.periodCount}
                            renderBreadcrumb={!!detailsShown}
                            onRenderBreadcrumb={() => renderPivotBreadcrumb(subquestionModifiedId)}
                            columns={headers}
                        />
                    </Card.Header>
                    <Card.Body>
                        {!chartMode || chartMode === CHART_MODE_TABLE ? (
                            <HorizontalTable
                                percentage={!!percentage[subquestionModifiedId]}
                                data={table}
                                tableId={`table_${subquestionModifiedId}`}
                                subQuestionDetails={detailsShown}
                                firstColumnTitle={
                                    detailsShown
                                        ? parameters?.firstColumnTitle
                                            ? parameters?.firstColumnTitle
                                            : parameters?.groupByQuestion
                                                ? parameters?.groupByQuestion.questionTitle
                                                : headTitle
                                        : headTitle
                                }
                                useZAxisValue={parameters?.groupByColumnKey === "project"}
                            />
                        ) : (
                            renderChart(table, detailsShown, NUMBER, undefined, parameters?.groupByColumnKey)
                        )}
                    </Card.Body>
                </Card>
            </Tab.Pane>
        );
    });

    return (
        <Tab.Container activeKey={tabIds.includes(tabActive) ? tabActive : defaultActive}>
            <Tab.Content>{rows.map((elem) => elem)}</Tab.Content>
        </Tab.Container>
    );
};

MatrixQuestion.propTypes = {
    subQuestion: PropTypes.object,
    collapsibleTablesDetails: PropTypes.array,
    modalSelectParameters: PropTypes.object,
    renderHeader: PropTypes.func,
    renderChart: PropTypes.func,
    renderPivotBreadcrumb: PropTypes.func,
    handleClickDownloadPivotQuestion: PropTypes.func,
    handleModalOpen: PropTypes.func,
    handlePivotShortcutSubmit: PropTypes.func,
    handlePercentageClick: PropTypes.func,
    getQuestionPath: PropTypes.func,
    getBreadcrumbPath: PropTypes.func,
    pivotShortcut: PropTypes.object,
    percentage: PropTypes.object,
    sinceBeginning: PropTypes.any,
    tabActive: PropTypes.string
};

export default MatrixQuestion;
